import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { updateProfile } from '../../api/auth.api';

const LangSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const { isAuthenticated } = useAuthStore();

  const languages = [
    { code: 'ko', flag: '🇰🇷', label: '한국어' },
    { code: 'en', flag: '🇺🇸', label: 'EN' },
    { code: 'ja', flag: '🇯🇵', label: '日本語' },
  ];

  const handleLanguageChange = async (langCode: string) => {
    i18n.changeLanguage(langCode);
    if (isAuthenticated) {
      try {
        await updateProfile({ preferences: { language: langCode } });
      } catch {
        // Silent fail — localStorage still has the value
      }
    }
  };

  return (
    <div className="inline-flex items-center bg-gray-100 dark:bg-slate-800 rounded-full p-1 text-xs">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
          className={`px-2 sm:px-3 py-2 min-h-[44px] min-w-[44px] rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 ${
            i18n.language === lang.code || i18n.language.startsWith(lang.code)
              ? 'bg-primary-600 text-white dark:bg-primary-500'
              : 'text-gray-700 hover:text-gray-900 dark:text-slate-300 dark:hover:text-slate-100'
          }`}
          aria-label={`Switch to ${lang.label}`}
        >
          <span className="flex items-center gap-1">
            <span className="text-base leading-none">{lang.flag}</span>
            <span className="hidden sm:inline">{lang.label}</span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default LangSwitcher;
